export default __webpack_public_path__ + "static/media/NorthernHackersBanner.ffe0686b.png";